export const Endpoint = ({ projectId, resultId }: Payload) =>
    `/vscanner/api/v2/projects/${projectId}/results/${resultId}`;

export type Payload = {
    projectId: string;
    resultId: string;
};

export type Response = void;
